import type { FaireProductEntity } from "../../entity_types/product";

export const p_rxt2bzr743: FaireProductEntity = {
  token: "p_rxt2bzr743",
  type: "product",
  name: "Botanical Wood Wall Art | Rustic Floral Sketch Sign",
  brandName: "The Rustic Charm",
  imageUrl:
    "https://cdn.faire.com/fastly/0a5c6d786b6eb6ce1eb71dcd01297ae207d519fbf50f282d0c42db3a576297dd.jpeg",
  priceDollars: 15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b61a539a10b6deefb42e87c46f0ba63b566af34dbdca99a6d0edb59609a1689c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
